import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a1b8bf64"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b8bf64')) {
      api.createRecord('a1b8bf64', component.options)
    } else {
      api.reload('a1b8bf64', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a1b8bf64", function () {
      api.rerender('a1b8bf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/Form.vue"
export default component.exports